export default __webpack_public_path__ + "static/media/perderjuego4.df315f13.png";